import React from 'react'
import { withTranslation } from "react-i18next";

const Description = (props) => {
  console.log("Description :: Component => Enter");
  /*console.log("Description :: Component :: description => "+props.description);
  console.log("Description :: Component :: Mobile Number => "+props.mobileNo);*/

  const { t } = props;

  return (
    <p className="headerdescription">{t(props.description)}{props.mobileNo ? props.mobileNo : ''}</p>                                                          
  )
};

export default withTranslation()(Description)
